import { installTf } from "@p0security/shared/integrations/resources/aws-rds/iac";

import { otherInstalledIntegration } from "../utils/resourcesInstalledUtil";
import { AwsRdsInstaller } from "./types";

const awsRdsIamWriteInstructions: AwsRdsInstaller["iam-write"]["instructions"] =
  (context, id) => {
    return {
      help: (
        <>
          To install P0 on this account, provision P0&apos;s access using
          Terraform:
        </>
      ),
      commands: {
        iac: [{ command: installTf(context, { vpcId: id }) }],
      },
    };
  };

export const awsRdsInstaller: AwsRdsInstaller = {
  "iam-write": {
    items: {
      accountId: {
        optionProvider: otherInstalledIntegration({
          integration: "aws",
          component: "iam-write",
        }),
      },
    },
    instructions: awsRdsIamWriteInstructions,
  },
};
